import React from 'react';
import { CREATION_CONTENT_TYPE, STYLES } from '../consts/consts';
import MainContent from '../../../../generic-components/Layout/MainContent';
import { StickyHeader } from './StickyHeader';
import { CreationFormWrapper } from './CreationFormWrapper';
import { ErrorModal } from '../../../../generic-components/ErrorModal';
import Spinner, { SpinnerColor } from '../../../../generic-components/Spinner';

interface IProps {
    contentType: number;
}

const Loader = () => (
  <div className='absolute inset-0 flex items-center justify-center'>
    <Spinner spinnerColor={SpinnerColor.Blue} height='2rem' width='2rem' />
  </div>
);

const Error = () => (
  <ErrorModal onClose={() => {}} onButtonClick={() => {}} />
);

/** ------------------------------------- * */

export const CreationContentSwitch = ({ contentType }: IProps) => {
  switch (contentType) {
    case CREATION_CONTENT_TYPE.ERROR:
      return <Error />;
    case CREATION_CONTENT_TYPE.LOADER:
      return <Loader />;

    case CREATION_CONTENT_TYPE.CONTENT:
      return (
        <MainContent className={STYLES.INVOICE_CREATION.CREATION_CONTENT_SWITCH.WRAPPER}>
          <div className={STYLES.INVOICE_CREATION.CREATION_CONTENT_SWITCH.FORM_CONTENT_WRAPPER}>
            <div className='absolute inset-0 flex justify-center overflow-y-scroll pt-[15px] pb-[50px]'>
              <CreationFormWrapper />
            </div>
          </div>
          <StickyHeader />

        </MainContent>
      );
    default:
      return <Loader />;
  }
};
